import { render, staticRenderFns } from "./IcoExpiration.vue?vue&type=template&id=2ea9c066&scoped=true"
import script from "./IcoExpiration.vue?vue&type=script&lang=js"
export * from "./IcoExpiration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9c066",
  null
  
)

export default component.exports